module.exports = __webpack_public_path__ + "img/def.6a3be654.png";